import script from "./HrDivider.vue?vue&type=script&setup=true&lang=js"
export * from "./HrDivider.vue?vue&type=script&setup=true&lang=js"

import "./HrDivider.vue?vue&type=style&index=0&id=8fe9dd40&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fe9dd40"]])

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator});
